import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
    selector: 'app-modal',
    template: `
    <div id="id_modal" (click)="onContainerClicked($event)" (keyup)="onKeyUp($event)" class="modal fade" tabindex="-1" [class.in]="visibleAnimate"
        [style.position]="fixed ? 'fixed' : 'absolute'" [style.display]="visible ? 'block' : 'none'" [style.opacity]="visibleAnimate ? 1 : 0">
        <div class="modal-dialog" [ngStyle]="{'width': width === '' ? null : width + 'px', 'margin-left': width === '' ? null : -width / 2 + 'px'}">
        <div class="modal-content">
            <div class="modal-header" [ngStyle]="{'display': (title === '' ? 'none' : 'block')}">
            <div class="app-modal-header">
                {{title}}
            </div>
            </div>
            <div class="modal-body">
            <div class="app-modal-body">
                {{content}}
                <ng-content select=".modal-custom-content"></ng-content>
            </div>
            </div>
            <div class="modal-footer">
            <div class="app-modal-footer">
                <button type="button" class="modal-btn-cancel" [ngStyle]="{'display': type === 'confirm' ? 'inline-block' : 'none'}" (click)="hide()">取消</button>
                <button type="button" class="modal-btn-confirm" [ngStyle]="{'display': type === 'alert' ? 'inline-block' : 'none'}" (click)="hide()">确定</button>
                <ng-content select=".modal-btn-confirm"></ng-content>
            </div>
            </div>
            <span class="app-modal-close" (click)="hide()">&times;</span>
        </div>
        </div>
    </div>
    `,
    styleUrls: ['./modal.css']
})
export class ModalComponent implements OnInit {
    @Input('fixed') fixed = false;
    @Output('result') dialogResult: EventEmitter<any> = new EventEmitter<any>();

    type = 'alert';
    width: any = '';
    title = '';
    content = '';

    ngOnInit() {
    }

    visible = false;
    visibleAnimate = false;

    show(): void {
        this.visible = true;
        setTimeout(() => {
            this.visibleAnimate = true;
            document.getElementById('id_modal').focus();  // 弹窗监测key
        }, 100);

    }

    ok(): void {
        this.dialogResult.emit('OK');
        this.hide();
    }

    cancle(): void {
        this.dialogResult.emit('Cancle');
        this.hide();
    }

    hide(): void {
        this.visibleAnimate = false;
        setTimeout(() => this.visible = false, 100);
    }

    onContainerClicked(event: MouseEvent): void {
        if ((<HTMLElement>event.target).classList.contains('modal')) {
            this.cancle();
        }
    }

    onKeyUp(event): void {
        // console.log(event);
        if (!event) return;
        if (event['keyCode'] === 13) {
            this.ok();
        } else if (event['keyCode'] === 27) {
            this.cancle();
        }
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/shared/components/modal/modal.component.ts